
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34030',
  depVersions: {
  "documents-public-ui": "static-1.34030",
  "client-types": "static-1.449",
  "documents-lib": "static-1.34035",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1954",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5419",
  "hs-test-utils": "static-1.7832",
  "hub-http": "static-1.6045",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11259",
  "I18n": "static-7.1577",
  "jasmine-immutable": "static-1.2843",
  "jasmine-runner": "static-1.6297",
  "lodash": "static-1.3",
  "quartz": "static-1.6768",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16477",
  "reporting-data": "static-1.66619",
  "reporting-testing-lib": "static-1.8552",
  "reporting-visualizations": "static-1.58695",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4591",
  "webpack-env": "static-1.54",
  "atom": "static-1.4895",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2314",
  "classnames": "static-2.10",
  "cssUtils": "static-1.741",
  "customer-data-filters-ui": "static-1.38983",
  "customer-data-objects": "static-1.7474",
  "customer-data-property-utils": "static-1.7905",
  "data-fetching-client": "static-1.9502",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4356",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85340",
  "FormUrlGenerator": "static-2.4553",
  "foundations-components": "static-1.7572",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11567",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6985",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3682",
  "property-translator": "static-1.5236",
  "quartz-config": "static-1.546",
  "quartz-core": "static-1.5987",
  "quick-fetch": "static-1.3761",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5199",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7987",
  "reference-resolvers-lite": "static-1.7920",
  "report-customization-components": "static-1.12576",
  "reporting-enablement": "static-1.22151",
  "reporting-reports": "static-1.66297",
  "reporting-snowflake": "static-1.55237",
  "reporting-ui-components": "static-2.63890",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4460",
  "sales-content-partitioning": "static-1.8760",
  "SalesContentIndexUI": "static-3.8937",
  "sanitize": "static-1.4300",
  "sanitize-text": "static-1.7970",
  "self-service-api": "static-1.10065",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1577",
  "signup-constants": "static-1.18469",
  "signup-ui-lego-core": "static-1.20479",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4596",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10820",
  "ui-addon-i18n": "static-1.10969",
  "ui-addon-react-router-dom": "static-1.9371",
  "ui-addon-upgrades": "static-9.17693",
  "ui-asset-management-lib": "static-1.10742",
  "ui-images": "static-2.1101",
  "UIComponents": "static-3.8206",
  "usage-tracker": "static-1.7161",
  "usage-tracker-container": "static-1.7151",
  "usage-tracker-core": "static-1.7011",
  "usage-tracker-public": "static-1.6972",
  "viral-links-lib": "static-1.6862",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3253",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3045",
  "quartz-webpack": "static-1.2992",
  "ai-components-ui-library": "static-1.8412",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4662",
  "foundations-theming": "static-1.4238",
  "quartz-auth": "static-1.443",
  "ui-business-units-lib": "static-1.8855",
  "usage-tracker-session-replay": "static-1.4847",
  "foundations-theming-base": "static-1.3223",
  "HeadJS": "static-2.715",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2943",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4152",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7750",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3445",
  "persist-promise": "static-1.3533",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.597",
  "hs-story-utils": "static-1.9252",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9529",
  "hubspotter-http": "static-1.4502",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7074",
  "crm-message-bus": "static-1.42427",
  "customer-data-filters-ui-msw-helpers": "static-1.21418",
  "customer-data-objects-ui-components": "static-1.12834",
  "customer-data-reference-ui-components": "static-1.12972",
  "customer-data-ui-utilities": "static-1.9649",
  "framework-builder-read-service-client": "static-1.3858",
  "framework-data-schema-quick-fetch": "static-1.6603",
  "framework-data-schema-resolvers": "static-1.6698",
  "inbound-db-properties-service-client": "static-1.3699",
  "multi-account-reference-resolvers": "static-1.799",
  "onboarding-tours": "static-1.16300",
  "reporting-datasets-permissions-lib": "static-1.13123",
  "ui-addon-teams": "static-1.21274",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67687",
  "customer-data-properties": "static-1.50858",
  "forms-ai-lib": "static-1.4044",
  "forms-utils-lib": "static-1.12213",
  "foundations-components-test-utils": "static-1.5055",
  "react-dnd-compat": "static-1.4446",
  "react-tinymce": "static-1.54681",
  "tinymce-config": "static-2.53807",
  "ui-gdpr-components": "static-1.10173",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3841",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1287",
  "ui-fonts": "static-1.521",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.800",
  "mobile-manifest-mixins": "static-1.488",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.433",
  "quartz-i18n": "static-1.443",
  "quartz-routing": "static-1.198",
  "quartz-test": "static-1.443",
  "quartz-tracking": "static-1.147",
  "batch-promise": "static-1.1376",
  "external-options-client-types": "static-1.4009",
  "react-colorpicker": "static-2.10036",
  "copilot-toolkit": "static-1.10593",
  "data-quality-ui-library": "static-1.12375",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6288",
  "reporting-action-components": "static-1.40714",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10017",
  "ui-addon-draggable-compat": "static-2.4079",
  "ui-addon-opt": "static-4.8210",
  "ui-shepherd-react": "static-3.9972",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24788",
  "hubspot-apollo-client": "static-1.4706",
  "sales-templates-service-types-lib": "static-1.4016",
  "merchandise-lib": "static-1.260",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5515",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3929",
  "timezone-utils": "static-2.5070",
  "bender-build-tools": "static-1.2970",
  "chatspot-core": "static-1.20425",
  "chirp-fetch": "static-1.1708",
  "bend-plugin-foundations-theming": "static-1.2721",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9527",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3648",
  "crm-pipelines-api-client-types": "static-1.3990",
  "multi-currency-client-types": "static-1.3541",
  "getting-started-shared-tasks": "static-1.17946",
  "growth-data-modal": "static-1.5184",
  "growth-onboarding-confetti": "static-1.2898",
  "growth-onboarding-next-action-utils": "static-1.1348",
  "navigation-components": "static-1.17344",
  "onboarding-tours-client": "static-1.4514",
  "onboarding-tours-utils": "static-1.366",
  "ui-shepherd-tracker": "static-1.7353",
  "ui-universal-auth": "static-1.8733",
  "user-context": "static-1.4925",
  "cms-field-types": "static-1.4632",
  "content-icons-ui": "static-1.2164",
  "integrations-lib": "static-1.15495",
  "calling-global-api": "static-1.63753",
  "calling-internal-common": "static-1.31120",
  "calling-lifecycle-internal": "static-1.65135",
  "calling-lifecycle-messages": "static-1.57429",
  "commerce-products-lib": "static-1.8923",
  "crm-links": "static-1.6092",
  "file-manager-components": "static-1.22970",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.505",
  "inbounddb-objects-service-types": "static-1.4072",
  "meetings-icalendar-utils-lib": "static-1.458",
  "object-builder-ui-client": "static-1.48066",
  "pipeline-validation-client-types": "static-1.3813",
  "property-value-citations": "static-1.1472",
  "pulse": "static-1.341",
  "smart-property-lib": "static-1.6008",
  "tiered-pricing": "static-1.864",
  "ui-addon-iframeable": "static-1.8872",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19513",
  "tinymce-themes": "static-1.55777",
  "data-token-picker": "static-1.16084",
  "hub-http-contrib": "static-1.2868",
  "interframe": "static-3.4614",
  "tinymce-data": "static-1.39892",
  "tinymce-plugins": "static-1.56921",
  "ui-addon-sales-email": "static-1.5039",
  "magpie-lib": "static-1.5420",
  "magpie-types": "static-1.4880",
  "simple-logging-lib": "static-1.2876",
  "content-assistance-lib": "static-1.7484",
  "dashboard-lib": "static-1.80718",
  "ExportDialog": "static-6.10212",
  "hubspot-prosemirror": "static-1.17665",
  "hubspot-prosemirror-plugins": "static-1.17657",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8519",
  "campaign-roi-lib": "static-1.8343",
  "feedback-loader": "static-1.28905",
  "apollo-link-hub-http": "static-2.4477",
  "hubspot-apollo-cache": "static-1.165",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2183",
  "purchase-motions-api": "static-1.5518",
  "trials-service-types": "static-1.3730",
  "growth-onboarding-next-action-components": "static-1.1376",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.550",
  "unified-auth-core-lib": "static-1.528",
  "getting-started-shared-tasks-store": "static-1.17064",
  "integrations-error-boundary-lib": "static-1.12910",
  "integrations-tracking-lib": "static-1.5414",
  "native-integrations-shared-strings": "static-1.7614",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10198",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31126",
  "shared-worker-versioning": "static-1.10864",
  "calling-usage-tracker": "static-1.6366",
  "voice-sms-access-library": "static-1.309",
  "customer-data-tracking": "static-1.6707",
  "commerce-permissions": "static-1.585",
  "products-iframe-lib": "static-1.7389",
  "products-ui-components-shared-msw-handlers": "static-1.9911",
  "location-customization-utils-lib": "static-1.8631",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3980",
  "video-components-external": "static-1.10633",
  "video-data-lib": "static-1.34291",
  "directed-graph": "static-1.765",
  "event-emitter": "static-1.773",
  "breeze-intelligence-kit": "static-1.5357",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9612",
  "fsm": "static-1.3557",
  "policy-lib": "static-1.6607",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9675",
  "navigation-messaging": "static-1.6671",
  "FileManagerLib": "static-1.38610",
  "NamespacedHubStyle": "static-2.8921",
  "FileManagerCore": "static-1.38469",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12082",
  "layout-dnd-utils": "static-1.11057",
  "react-codemirror": "static-1.10452",
  "ui-addon-emoji-picker": "static-1.9713",
  "ui-brand-identity-lib": "static-1.14025",
  "ui-addon-video-player": "static-1.8522",
  "ui-coaching-tips": "static-1.28002",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8393",
  "payment-link-components": "static-1.23002",
  "EmailSignatureEditor": "static-1.23961",
  "eligibility-engine-service-types": "static-1.3011",
  "universal-page-editor-lib": "static-1.2825",
  "calling-orchestration-schema": "static-1.35086",
  "sales-views-client-types": "static-1.4112",
  "crm-record-cards-service-types": "static-1.3468",
  "content-media-composition-data-lib": "static-1.11538",
  "content-media-compositions": "static-2.15545",
  "media-bridge-lib": "static-1.18607",
  "trellis-story-utils": "static-1.4346",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5647",
  "FileManagerImages": "static-1.36121",
  "video-components": "static-1.12636",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4357",
  "video-embed": "static-1.35125",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67762",
  "layout-data-lib": "static-1.9382",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6408",
  "commerce-tours-lib": "static-1.5755",
  "growth-onboarding-reliability": "static-1.4912",
  "sales-checkout-service-client": "static-1.3493",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21349",
  "sales-email-signature-service-client": "static-1.3669",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21424",
  "outpost": "static-1.4029",
  "advanced-menus-core": "static-1.14852",
  "advanced-menus-lib": "static-1.11823",
  "ui-memberships-settings-lib": "static-1.33505",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14851",
  "simple-menus-lib": "static-1.16368"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34030",
  "client-types": "/client-types/static-1.449",
  "documents-lib": "/documents-lib/static-1.34035",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1954",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5419",
  "hs-test-utils": "/hs-test-utils/static-1.7832",
  "hub-http": "/hub-http/static-1.6045",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11259",
  "I18n": "/I18n/static-7.1577",
  "jasmine-immutable": "/jasmine-immutable/static-1.2843",
  "jasmine-runner": "/jasmine-runner/static-1.6297",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6768",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16477",
  "reporting-data": "/reporting-data/static-1.66619",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8552",
  "reporting-visualizations": "/reporting-visualizations/static-1.58695",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4591",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4895",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2314",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.741",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38983",
  "customer-data-objects": "/customer-data-objects/static-1.7474",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7905",
  "data-fetching-client": "/data-fetching-client/static-1.9502",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4356",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85340",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4553",
  "foundations-components": "/foundations-components/static-1.7572",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11567",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6985",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3682",
  "property-translator": "/property-translator/static-1.5236",
  "quartz-config": "/quartz-config/static-1.546",
  "quartz-core": "/quartz-core/static-1.5987",
  "quick-fetch": "/quick-fetch/static-1.3761",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5199",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7987",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7920",
  "report-customization-components": "/report-customization-components/static-1.12576",
  "reporting-enablement": "/reporting-enablement/static-1.22151",
  "reporting-reports": "/reporting-reports/static-1.66297",
  "reporting-snowflake": "/reporting-snowflake/static-1.55237",
  "reporting-ui-components": "/reporting-ui-components/static-2.63890",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4460",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8760",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8937",
  "sanitize": "/sanitize/static-1.4300",
  "sanitize-text": "/sanitize-text/static-1.7970",
  "self-service-api": "/self-service-api/static-1.10065",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1577",
  "signup-constants": "/signup-constants/static-1.18469",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20479",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4596",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10820",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10969",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9371",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17693",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10742",
  "ui-images": "/ui-images/static-2.1101",
  "UIComponents": "/UIComponents/static-3.8206",
  "usage-tracker": "/usage-tracker/static-1.7161",
  "usage-tracker-container": "/usage-tracker-container/static-1.7151",
  "usage-tracker-core": "/usage-tracker-core/static-1.7011",
  "usage-tracker-public": "/usage-tracker-public/static-1.6972",
  "viral-links-lib": "/viral-links-lib/static-1.6862",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3253",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3045",
  "quartz-webpack": "/quartz-webpack/static-1.2992",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8412",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4662",
  "foundations-theming": "/foundations-theming/static-1.4238",
  "quartz-auth": "/quartz-auth/static-1.443",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8855",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4847",
  "foundations-theming-base": "/foundations-theming-base/static-1.3223",
  "HeadJS": "/HeadJS/static-2.715",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2943",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4152",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7750",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3445",
  "persist-promise": "/persist-promise/static-1.3533",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.597",
  "hs-story-utils": "/hs-story-utils/static-1.9252",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9529",
  "hubspotter-http": "/hubspotter-http/static-1.4502",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7074",
  "crm-message-bus": "/crm-message-bus/static-1.42427",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21418",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12834",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12972",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9649",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3858",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6603",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6698",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3699",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.799",
  "onboarding-tours": "/onboarding-tours/static-1.16300",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13123",
  "ui-addon-teams": "/ui-addon-teams/static-1.21274",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67687",
  "customer-data-properties": "/customer-data-properties/static-1.50858",
  "forms-ai-lib": "/forms-ai-lib/static-1.4044",
  "forms-utils-lib": "/forms-utils-lib/static-1.12213",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5055",
  "react-dnd-compat": "/react-dnd-compat/static-1.4446",
  "react-tinymce": "/react-tinymce/static-1.54681",
  "tinymce-config": "/tinymce-config/static-2.53807",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10173",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3841",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1287",
  "ui-fonts": "/ui-fonts/static-1.521",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.800",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.488",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.433",
  "quartz-i18n": "/quartz-i18n/static-1.443",
  "quartz-routing": "/quartz-routing/static-1.198",
  "quartz-test": "/quartz-test/static-1.443",
  "quartz-tracking": "/quartz-tracking/static-1.147",
  "batch-promise": "/batch-promise/static-1.1376",
  "external-options-client-types": "/external-options-client-types/static-1.4009",
  "react-colorpicker": "/react-colorpicker/static-2.10036",
  "copilot-toolkit": "/copilot-toolkit/static-1.10593",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12375",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6288",
  "reporting-action-components": "/reporting-action-components/static-1.40714",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10017",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4079",
  "ui-addon-opt": "/ui-addon-opt/static-4.8210",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9972",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24788",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4706",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4016",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5515",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3929",
  "timezone-utils": "/timezone-utils/static-2.5070",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "chatspot-core": "/chatspot-core/static-1.20425",
  "chirp-fetch": "/chirp-fetch/static-1.1708",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2721",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9527",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3648",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3990",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3541",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17946",
  "growth-data-modal": "/growth-data-modal/static-1.5184",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2898",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1348",
  "navigation-components": "/navigation-components/static-1.17344",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4514",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.366",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7353",
  "ui-universal-auth": "/ui-universal-auth/static-1.8733",
  "user-context": "/user-context/static-1.4925",
  "cms-field-types": "/cms-field-types/static-1.4632",
  "content-icons-ui": "/content-icons-ui/static-1.2164",
  "integrations-lib": "/integrations-lib/static-1.15495",
  "calling-global-api": "/calling-global-api/static-1.63753",
  "calling-internal-common": "/calling-internal-common/static-1.31120",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65135",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57429",
  "commerce-products-lib": "/commerce-products-lib/static-1.8923",
  "crm-links": "/crm-links/static-1.6092",
  "file-manager-components": "/file-manager-components/static-1.22970",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.505",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4072",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.458",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48066",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3813",
  "property-value-citations": "/property-value-citations/static-1.1472",
  "pulse": "/pulse/static-1.341",
  "smart-property-lib": "/smart-property-lib/static-1.6008",
  "tiered-pricing": "/tiered-pricing/static-1.864",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8872",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19513",
  "tinymce-themes": "/tinymce-themes/static-1.55777",
  "data-token-picker": "/data-token-picker/static-1.16084",
  "hub-http-contrib": "/hub-http-contrib/static-1.2868",
  "interframe": "/interframe/static-3.4614",
  "tinymce-data": "/tinymce-data/static-1.39892",
  "tinymce-plugins": "/tinymce-plugins/static-1.56921",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5039",
  "magpie-lib": "/magpie-lib/static-1.5420",
  "magpie-types": "/magpie-types/static-1.4880",
  "simple-logging-lib": "/simple-logging-lib/static-1.2876",
  "content-assistance-lib": "/content-assistance-lib/static-1.7484",
  "dashboard-lib": "/dashboard-lib/static-1.80718",
  "ExportDialog": "/ExportDialog/static-6.10212",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17665",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17657",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8519",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8343",
  "feedback-loader": "/feedback-loader/static-1.28905",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4477",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.165",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2183",
  "purchase-motions-api": "/purchase-motions-api/static-1.5518",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1376",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.550",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.528",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17064",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12910",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5414",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7614",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10198",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31126",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10864",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6366",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.309",
  "customer-data-tracking": "/customer-data-tracking/static-1.6707",
  "commerce-permissions": "/commerce-permissions/static-1.585",
  "products-iframe-lib": "/products-iframe-lib/static-1.7389",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9911",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8631",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3980",
  "video-components-external": "/video-components-external/static-1.10633",
  "video-data-lib": "/video-data-lib/static-1.34291",
  "directed-graph": "/directed-graph/static-1.765",
  "event-emitter": "/event-emitter/static-1.773",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5357",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9612",
  "fsm": "/fsm/static-1.3557",
  "policy-lib": "/policy-lib/static-1.6607",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9675",
  "navigation-messaging": "/navigation-messaging/static-1.6671",
  "FileManagerLib": "/FileManagerLib/static-1.38610",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8921",
  "FileManagerCore": "/FileManagerCore/static-1.38469",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12082",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11057",
  "react-codemirror": "/react-codemirror/static-1.10452",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9713",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14025",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8522",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28002",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8393",
  "payment-link-components": "/payment-link-components/static-1.23002",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23961",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2825",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35086",
  "sales-views-client-types": "/sales-views-client-types/static-1.4112",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3468",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11538",
  "content-media-compositions": "/content-media-compositions/static-2.15545",
  "media-bridge-lib": "/media-bridge-lib/static-1.18607",
  "trellis-story-utils": "/trellis-story-utils/static-1.4346",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5647",
  "FileManagerImages": "/FileManagerImages/static-1.36121",
  "video-components": "/video-components/static-1.12636",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4357",
  "video-embed": "/video-embed/static-1.35125",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67762",
  "layout-data-lib": "/layout-data-lib/static-1.9382",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6408",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5755",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4912",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3493",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21349",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3669",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21424",
  "outpost": "/outpost/static-1.4029",
  "advanced-menus-core": "/advanced-menus-core/static-1.14852",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11823",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33505",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14851",
  "simple-menus-lib": "/simple-menus-lib/static-1.16368"
}
};
